import React from 'react';
import type { EntryPointComponent } from 'react-relay';
import { SummaryStateContainer } from '@atlassian/jira-issue-smart-request-summary-state/src/ui/index.tsx';
import { Trigger } from './ui/index.tsx';

export type RuntimeProps = {
	totalComments?: number;
	triggerRef?: React.Ref<HTMLButtonElement>;
	isCompact: boolean;
	hasComments?: boolean;
};

export const SmartRequestSummaryTrigger: EntryPointComponent<{}, {}, RuntimeProps, {}> = ({
	props: { triggerRef, ...props },
}) => (
	<SummaryStateContainer>
		<Trigger {...props} ref={triggerRef} />
	</SummaryStateContainer>
);
